module.exports = __webpack_public_path__ + "img/MADDEN23-banner_day3.b0e9fdd8.png";